/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type - handles both Date objects and ISO strings */
  Date: { input: string; output: string; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type MeType = {
  __typename?: 'MeType';
  connectUserId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  featureFlags?: Maybe<Scalars['JSON']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  labUserId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  messagingMailboxId?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  practiceId?: Maybe<Scalars['String']['output']>;
  practiceWebsite?: Maybe<Scalars['String']['output']>;
  profileName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerImageUrl?: Maybe<Scalars['String']['output']>;
  sfUsername?: Maybe<Scalars['String']['output']>;
  userType: UserType;
};

export type MyPermissionsType = {
  __typename?: 'MyPermissionsType';
  rules: Scalars['JSON']['output'];
};

export type Query = {
  __typename?: 'Query';
  clevelandHeartlabSessionUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the enriched session profile for the authenticated user */
  me: MeType;
  /** Returns packed CASL rules for the authenticated user. Hydrate client-side with createMongoAbility(rules). */
  myPermissions: MyPermissionsType;
};

/** The type of user in the system */
export type UserType =
  | 'MEMBER'
  | 'PROVIDER'
  | 'STAFF';

export type ClevelandHeartLabSessionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type ClevelandHeartLabSessionUrlQuery = { __typename?: 'Query', clevelandHeartlabSessionUrl?: string | null };


export const ClevelandHeartLabSessionUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ClevelandHeartLabSessionUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"clevelandHeartlabSessionUrl"}}]}}]} as unknown as DocumentNode<ClevelandHeartLabSessionUrlQuery, ClevelandHeartLabSessionUrlQueryVariables>;